import axiosInstance from "../services/axios";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { hasRole, ROLE_SUPER_ADMIN } from "../utils/token";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [token, setToken_] = useState(localStorage.getItem("token"));
  const [isReady, setIsReady] = useState(false);

  const setToken = (newToken) => {
    setToken_(newToken);
  };

  const logout = () => {
    setToken_(null);
    localStorage.removeItem('token');
    delete axiosInstance.defaults.headers.common["Authorization"];
    setIsReady(false);
  };

  useEffect(() => {
    if (token) {
      axiosInstance.defaults.headers.common["Authorization"] = "Bearer " + token;
      localStorage.setItem('token',token);
    } else {
      delete axiosInstance.defaults.headers.common["Authorization"];
      localStorage.removeItem('token')
    }
    setIsReady(true);
  }, [token]);

  // Lu dans les claims du jeton : évite un appel réseau supplémentaire, et le
  // rôle y est présent dès que le compte est promu côté API. Sert uniquement à
  // l'affichage, l'API restant seule juge des droits réels.
  const isSuperAdmin = useMemo(
    () => hasRole(token, ROLE_SUPER_ADMIN),
    [token]
  );

  const contextValue = useMemo(
    () => ({
      token,
      setToken,
      logout,
      isReady,
      isSuperAdmin,
    }),
    [token, isReady, isSuperAdmin]
  );

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export default AuthProvider;
